import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Cmed from '@/view/record/cmed/Cmed'

export default {
  path: '/cmed',
  name: 'Cmed',
  components: {
    default: Cmed,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'CMED' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/CmedRoute.js